import axios from 'axios';
import { DonorURL } from '../../../config/UrlEndPoint';


// items => filtered/sorted result
export function verifyDonation(data) {
  return axios.post(`${DonorURL}verify_donation`, data);
}